module.exports = __webpack_public_path__ + "static/media/noticia7.45cb9a14.jpg";